import { __rest } from '../../../../../../_virtual/_tslib.js';
import '@helix/helix-icon/outlined';
import React, { useState, useRef, useEffect } from 'react';
import '@helix/helix-icon';
import NavbarBadge from './NavbarBadge.js';
import { checkIfChildIsA, getTarget } from './NavbarHelpers.js';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';

const NavbarMenuItem = (_a) => {
    var { menuItem, highlightedIndex, index, location, getItemProps, itemFormatter, linkWrapper, className } = _a, rest = __rest(_a, ["menuItem", "highlightedIndex", "index", "location", "getItemProps", "itemFormatter", "linkWrapper", "className"]);
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const useCheckmarkActive = false;
    const activeCheckmark = null;
    const formatMenuItem = () => (itemFormatter ? itemFormatter(menuItem) : menuItem.label);
    const itemContent = (menuItem) => {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: 'dropdown-menu-item-content' },
                React.createElement("span", null,
                    menuItem.label,
                    menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && (React.createElement(NavbarBadge, null, menuItem.badge.label))),
                activeCheckmark)));
    };
    const renderDropdownItem = (dropdownItem, dropdownIndex, isChild = false) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (React.createElement("li", Object.assign({ key: dropdownIndex, className: `
                ${dropdownIndex === highlightedIndex ? 'highlighted' : ''}
                ${dropdownItem.active && !useCheckmarkActive ? 'active' : ''} 
                ${dropdownItem.divider ? 'divider' : ''} 
                ${dropdownItem.header ? 'section-header section-header-bold' : ''} 
                ${isChild ? 'helix-dropdown-menu__sub-menu-item' : ''}
                ${dropdownItem.disabled ? ' disabled' : ''} 
                ${isChild && !isOpen ? 'helix-dropdown-menu__sub-menu-item--closed' : ''}
                ${(dropdownItem.url && dropdownItem.url === (location === null || location === void 0 ? void 0 : location.pathname)) ||
                dropdownItem.active ||
                (dropdownItem.activePathname && dropdownItem.activePathname === (location === null || location === void 0 ? void 0 : location.pathname))
                ? 'selected-item'
                : ''}
                ${className ? className : ''}
            ` }, rest, getItemProps({
            item: dropdownItem,
            disabled: dropdownItem.disabled || (isChild && !isOpen) || dropdownItem.divider || dropdownItem.header,
            index: dropdownIndex,
            ref: (ref) => (menuRef.current = ref)
        })), dropdownItem.url ? (dropdownItem.disabled ? (React.createElement("div", { className: 'menu-item-content-wrapper' }, itemFormatter ? itemFormatter(dropdownItem) : dropdownItem.label)) : (React.createElement(React.Fragment, null, linkWrapper ? (React.cloneElement(linkWrapper({
            item: dropdownItem,
            props: {}
        }), {
            children: checkIfChildIsA(linkWrapper, dropdownItem) ? (React.cloneElement((_b = linkWrapper({
                item: dropdownItem,
                props: Object.assign({}, (_a = linkWrapper({
                    item: dropdownItem,
                    props: {
                        children: null
                    }
                })) === null || _a === void 0 ? void 0 : _a.props)
            })) === null || _b === void 0 ? void 0 : _b.props.children, {
                children: (React.createElement(React.Fragment, null, (_d = linkWrapper({
                    item: dropdownItem,
                    props: Object.assign({}, (_c = linkWrapper({
                        item: dropdownItem,
                        props: {
                            children: null
                        }
                    })) === null || _c === void 0 ? void 0 : _c.props)
                })) === null || _d === void 0 ? void 0 :
                    _d.props.children.props.children,
                    dropdownItem.badge &&
                        dropdownItem.badge.label !== undefined &&
                        !dropdownItem.badge.hidden && (React.createElement(NavbarBadge, null, dropdownItem.badge.label))))
            })) : (React.createElement(React.Fragment, null,
                ((_e = linkWrapper({
                    item: dropdownItem,
                    props: {
                        children: null
                    }
                })) === null || _e === void 0 ? void 0 : _e.props) &&
                    ((_f = linkWrapper({
                        item: dropdownItem,
                        props: {
                            children: null
                        }
                    })) === null || _f === void 0 ? void 0 : _f.props.children) &&
                    ((_h = linkWrapper({
                        item: dropdownItem,
                        props: Object.assign({}, (_g = linkWrapper({
                            item: dropdownItem,
                            props: {
                                children: null
                            }
                        })) === null || _g === void 0 ? void 0 : _g.props)
                    })) === null || _h === void 0 ? void 0 : _h.props.children),
                dropdownItem.badge &&
                    dropdownItem.badge.label !== undefined &&
                    !dropdownItem.badge.hidden && (React.createElement(NavbarBadge, null, dropdownItem.badge.label))))
        })) : (React.createElement("a", Object.assign({ href: dropdownItem.url }, getTarget(dropdownItem)),
            React.createElement(React.Fragment, null, itemFormatter
                ? itemFormatter(dropdownItem)
                : itemContent(dropdownItem))))))) : (React.createElement("div", { className: 'menu-item-content-wrapper' },
            React.createElement(React.Fragment, null,
                " ",
                itemFormatter ? itemFormatter(dropdownItem) : itemContent(dropdownItem))))));
    };
    useEffect(() => {
        if (menuItem.toggleDropdown !== undefined) {
            setIsOpen((prev) => !prev);
        }
    }, [menuItem.toggleDropdown]);
    return (React.createElement(React.Fragment, null, menuItem.menuItems ? (React.createElement(React.Fragment, null,
        React.createElement("li", Object.assign({ className: `
                            ${menuItem.menuItems ? 'helix-dropdown-menu__overflow-dropdown-item' : ''} 
                            ${index === highlightedIndex ? 'highlighted' : ''}
                            ${menuItem.disabled ? ' disabled' : ''} 
                            ${className ? className : ''}` }, rest, getItemProps({
            item: menuItem,
            disabled: menuItem.disabled,
            index
        }), { onClick: () => setIsOpen((prev) => !prev) }),
            React.createElement("div", { className: 'menu-item-content-wrapper' },
                React.createElement("span", { className: 'menu-item-label' }, menuItem.url && !menuItem.disabled ? (React.createElement(React.Fragment, null, linkWrapper && menuItem == undefined ? (linkWrapper({ item: menuItem })) : (React.createElement("a", { href: menuItem.url }, formatMenuItem())))) : (formatMenuItem())),
                React.createElement(NavbarHelixIcon, { iconName: isOpen ? 'dropdown_open' : 'dropdown_closed' }))),
        menuItem.menuItems.map((dropdownItem, dropdownIndex) => renderDropdownItem(dropdownItem, index + dropdownIndex + 1, true)))) : (renderDropdownItem(menuItem, index))));
};

export { NavbarMenuItem as default };
//# sourceMappingURL=NavbarMenuItem.js.map
